export default "__VITE_ASSET__BNYWK79E__"